module.exports = __webpack_public_path__ + "static/media/klax.bf8e28c7.webp";